import React, { Component } from 'react';
import { ButtonModal } from 'sos-common/js/components/ButtonModal/ButtonModal';
import 'sos-eservice-common/js/components/EServiceFormMenu/EServiceFormMenu.scss';
import EventService from '../CalculationComponents/calculationComponents.eventservice';
import { SAVE, SAVE_AND_CLOSE } from '../StatsbidragSubmitAction/StatsbidragSubmitAction';

export interface StatsbidragFormMenuProps {}
export interface StatsbidragFormMenuState {
  canUserSave: boolean;
}

/**
 * Renders the Save, Save and Close buttons that is available for every forms page. However, this component is not responsible of doing the operations.
 * The actions and the payloads are being sent to the event service.
 */
export class StatsbidragFormMenu extends Component<{}, StatsbidragFormMenuState> {
  constructor(props: StatsbidragFormMenuProps) {
    super(props);
    this.state = {
      canUserSave: true,
    };
  }

  save = (e: React.MouseEvent) => {
    e.preventDefault();
    EventService.fire(`form-submit-action`, { detail: SAVE });
  };

  saveAndClose = () => {
    EventService.fire(`form-submit-action`, { detail: SAVE_AND_CLOSE });
  };

  /**
   * This is required to decide whether the save button will be activated or not; depending on the logged-in user's authorization level
   */
  componentDidMount = () => {
    EventService.subscribe('FORMMENU_SAVEBUTTON_STATE', (e: CustomEvent) => {
      this.setState({
        canUserSave: e.detail,
      });
    });
  };

  public render() {
    return (
      <div>
        <nav className="eservice-navigation">
          <div className="eservice-navigation__topnav">
            <div></div>
            <div className="eservice-navigation__topnav--right">
              <button
                className="button eservice-navigation__saveorderbtn"
                disabled={!this.state.canUserSave}
                onClick={this.save}>
                Spara
              </button>
              <ButtonModal
                buttonText="Spara och stäng"
                buttonCss="button button--white"
                modalAction=""
                modalHeading="Spara och stäng"
                modalBody="Är du säker på att du vill spara och stänga?"
                modalCancelText="Avbryt"
                modalCancelCss="button button--white"
                modalActionText="Spara och stäng"
                modalActionCss="button"
                modalActionUrl="#"
                callBackLink="#"
                isButtonDisabled={!this.state.canUserSave}
                onActionCompleted={this.saveAndClose}
              />
            </div>
          </div>
        </nav>
      </div>
    );
  }
}
